import { request_list, export_list } from '@/commons/hpod';
import Vue from 'vue';
var FileSaver = require('file-saver');

const state = {
    all: {
        data: [],
        total: 0,
        totals: {}
    },
    loading: false,
    selected: {}
};

const getters = {
};

const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/customer-debt', data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('report/customer-debt', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"
            });
            FileSaver.saveAs(blob, `BaoCaoCongNoKhachHang_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    }
};

const mutations = {
    setList(state, data) {
        state.all = {
            data: data.data || [],
            total: data.total || 0,
            totals: data.totals || {}
        };
    },
    
    setLoading(state, { loading }) {
        state.loading = loading;
    },
    
    setSelected(state, item) {
        state.selected = item;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
